import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AsyncReduxState, initialAsyncReduxState } from '../../defaults';

export type ChangePasswordState = AsyncReduxState<{
    hasChangedSuccessfully: boolean;
}>;

const initialState: ChangePasswordState = {
    ...initialAsyncReduxState,
    hasChangedSuccessfully: false,
};

const changePasswordSlice = createSlice({
    name: 'changePasswordSlice',
    initialState,
    reducers: {
        setIsLoading(state, action: PayloadAction<boolean>): ChangePasswordState {
            return {
                ...state,
                isLoading: action.payload,
            };
        },
        setIsSuccessful(state, action: PayloadAction<boolean>): ChangePasswordState {
            return {
                ...state,
                isSuccessful: action.payload,
            };
        },
        setError(state, action: PayloadAction<string>): ChangePasswordState {
            return {
                ...state,
                error: action.payload,
            };
        },
        setHasChangedSuccessfully(state, action: PayloadAction<boolean>): ChangePasswordState {
            return {
                ...state,
                hasChangedSuccessfully: action.payload,
            };
        },
    },
});

export const {
    setIsLoading,
    setIsSuccessful,
    setError,
    setHasChangedSuccessfully,
} = changePasswordSlice.actions;

export default changePasswordSlice;
